var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaOp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2249 8.524L11.9407 23.5174H7.84071L4.74823 11.552C4.56048 10.815 4.39723 10.545 3.82623 10.2345C2.89398 9.72874 1.35449 9.25425 0 8.95975L0.0919993 8.524H6.69171C7.53296 8.524 8.28921 9.084 8.4802 10.0527L10.1134 18.7287L14.1499 8.52375L18.2249 8.524ZM34.2893 18.6222C34.3058 14.665 28.8173 14.447 28.8551 12.6792C28.8668 12.1412 29.3791 11.5692 30.5003 11.4232C31.0561 11.3505 32.5873 11.295 34.3241 12.0942L35.0053 8.91475C34.0721 8.576 32.8713 8.25 31.3773 8.25C27.5436 8.25 24.8456 10.288 24.8229 13.2062C24.7981 15.3647 26.7486 16.5692 28.2181 17.2865C29.7298 18.0209 30.2371 18.4929 30.2313 19.1499C30.2206 20.1557 29.0256 20.5997 27.9089 20.6172C25.9594 20.6472 24.8281 20.0897 23.9264 19.6704L23.2234 22.9552C24.1296 23.3709 25.8024 23.7337 27.5366 23.7519C31.6113 23.7519 34.2768 21.7392 34.2893 18.6222ZM44.4128 23.5174H48L44.8688 8.524H41.5578C40.8133 8.524 40.1853 8.9575 39.9073 9.62399L34.0871 23.5174H38.1598L38.9683 21.2779H43.9445L44.4128 23.5174ZM40.085 18.2049L42.1265 12.5755L43.3015 18.2049H40.085ZM23.7666 8.524L20.5594 23.5174H16.6809L19.8894 8.524H23.7666Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaOp);
export default __webpack_public_path__ + "static/media/Visa-op.5ee3b5d73e3f6e6a5ee0cbda43ce935b.svg";
export { ForwardRef as ReactComponent };